import {constants} from './index'

export default {
  getParameterByName,
  path,
  fullHostUrl,
  isUrl,
  isUrlInStr,
  isFullPath
};

function isUrl(str) {
  return !!str ? /^https?:\/\//.test(str) : false
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function path (path, old_dashboard_host = false) {
  if (constants.mobileApp() || old_dashboard_host)
    return old_dashboard_host ? fullOldHostUrl(path) : fullHostUrl(path)
  else
    return path
}

function fullHostUrl(path) {
  if (isFullPath(path)) return path
  else if (constants.hostBrand().frontage_base_url) return constants.hostBrand().frontage_base_url + path
  else return HostBaseUrl + path
}

function isUrlInStr(str) {
  const regex = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g);
  return regex.test(str);
}

function fullOldHostUrl(path) {
  if (isFullPath(path)) return path
  else if (constants.hostBrand().system_base_url) return constants.hostBrand().system_base_url + path
  else return constants.appConfig().OldHostBaseUrl + path
}

function isFullPath (path) {
  return path.indexOf('http://') == 0 || path.indexOf('https://') == 0 || path.indexOf('file://') == 0
}
